import { get, put, post } from '@core/request';

/*
    接口服务--用户库
*/

// 用户列表
export const getExpertListApi = params => {
    return get('/user/ssomemberexperts/list', params);
};

//创建
export const saveExpertApi = data => {
    return post('/user/ssomemberexperts/save', data);
};
// 删除用户
export const deleteExpertApi = params => {
    return get('/user/ssomemberexperts/delete', params);
};

/**
 * 专家详情（整合原 base-info / extend-info / account-info）
 * @param {Object} params 参数
 * @param {number} params.id 专家 ID
 * @returns {Promise<Object>} 专家详情
 */
export const showExpertApi = params => get('/user/ssomemberexperts/show', params);

// 编辑
export const editInfoApi = params => {
    return put('user/ssomemberexperts/edit', params);
};

//上传图片

export const postExpertApi = (data, opinion) => {
    return post('/user/file', data, opinion);
};

//删除联系人信息
export const delPeopleApi = params => {
    return get('user/ssomembercontacts/delete', params);
};

//删除联系人信息
export const delPoistionApi = params => {
    return get('user/ssomemberworkexperiences/delete', params);
};

// 修改专家手机号
export const changeExpertMobile = data => put('/user/ssomemberexperts/update-phone', data);

/**
 * 更改专家启用/禁用状态（接口无禁用理由字段，理由仅用于前端操作日志）
 * @param {{ id: number, status: number }} params - status: 0 正常，1 禁用
 */
export const changeExpertStatusApi = params => put('/user/ssomemberexperts/changeStatus', {}, { params });

/**
 * 调整专家可信度
 * @param {{ id: number, credibility: 'high' | 'medium' | 'low' }} params
 */
export const changeExpertCredibilityApi = params => put('/user/ssomemberexperts/changeCredibility', {}, { params });

//国籍列表
export const sysdictionaryApi = params => {
    return get('dataengine/api/sysdictionary/getByGroup', params);
};

// 检查百度百科词条是否存在
export const checkBaiduBaikeEntryApi = params => {
    return get('user/data/checkBaiduBaikeEntry', params);
};

// 查询综评基础维度
export const getExpertEvalDimensionsApi = params => {
    return get('/user/boss/expertEvalRecord/getExpertEvalDimensions', params);
};

// 保存专家评价记录
export const saveExpertEvalRecordApi = data => {
    return post('/user/boss/expertEvalRecord/save', data);
};

// 查询专家综评列表
export const getEvalsPageApi = params => {
    return get('/user/boss/expertEvalRecord/getEvalsPage', params);
};

// 查询综评用户评价记录
export const getExpertEvalRecordsApi = params => {
    return get('/user/boss/expertEvalRecord/getExpertEvalRecords', params);
};

// 根据专家id查询专家用户评价统计
export const getEvalTotalByExpertIdApi = params => {
    return get('/user/boss/expertEvalRecord/getEvalTotalByExpertId', params);
};

// 查询机构信息
export const getOrganizations = data => {
    return post('/dataengine/api/organizations/search', data);
};

// 新增机构
export const createOrganization = data => {
    return post('/dataengine/api/organizations/apply', data);
};
